import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";
import modules from "./modules";

import * as modusModel from "./datamodel/modus.model";
import { OSDTooltips, THEMEN_COLORS } from "./datamodel/constants";

Vue.use(Vuex);

const state = {
  themen_colors: THEMEN_COLORS,
  texte: {
    modusData: modusModel.createNew("texte"),
    merzListe: null
  },
  werbe: {
    modusData: modusModel.createNew("werbe"),
    merzListe: null
  },
  ursonate_noten: {
    modusData: modusModel.createNew("ursonate_noten"),
    merzListe: null
  },
  ursonate_texte: {
    modusData: modusModel.createNew("ursonate_texte"),
    merzListe: null
  },

  cache: {
    documents: []
  },
  personen: {
    collection2: null,
  },

  merzListe: null,
  bibliographie: null,
  orteundwege: null,
  ursonateData: null,
  ursonateData2: null,
  OSDTooltips: OSDTooltips
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: modules
});



// WEBPACK FOOTER //
// ./src/store/index.js